export default __webpack_public_path__ + "static/media/el_6.7415b268.mp3";